import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography } from '@drone-js/core';
import { RootState } from 'store/store.types';
import { hideGenericError } from 'store/slice/error';
import { selectConfigFromBootstrap } from 'store/slice/bootstrap';

const GenericErrorTimeout = 5; // Timeout in seconds

const GenericErrorOverlay: React.FC<{}> = React.memo((props) => {
    const error = useSelector((state: RootState) => state.error.genericError);
    const config = useSelector(selectConfigFromBootstrap);
    const dispatch = useDispatch();

    React.useEffect(() => {
        // We must not dispatch always, otherwise React will re-render whole tree from App level.
        if (error.show) {
            setTimeout(
                () => {
                    dispatch(hideGenericError());
                    error.onDismiss && error.onDismiss();
                },
                (error.timeout || GenericErrorTimeout) * 1000,
            );
        }
    }, [dispatch, error, props]);

    if (!error.show) {
        return null;
    }

    return (
        <Box width="100%" textAlign="center" zIndex={100} backgroundColor="feedback.negative" px="12" py="16" position={config.browser.isDesktop ? 'relative' : 'fixed'}>
            <Typography data-testid="generic-error-message" variant="body-s" textColor="base.inverted">
                {error.message || config.cms[130741]}
            </Typography>
        </Box>
    );
});
GenericErrorOverlay.displayName = 'GenericErrorOverlay';

export default GenericErrorOverlay;
